<template>
  <div class="home" v-cloak>
    <img src="../assets/img/buttom.png" class="buttom-img"/>
    <div class="title-outer">
      <img src="../assets/img/title1.png" class="title1-img"/>
    </div>
    <!--模块介绍区域-->
    <div class="modules-area reveal-left z-mar">
      <div class="modules-img">
        <img class="image" src="../assets/img/ic_1.png"/>
      </div>
      <div class="modules-text">
        <p class="modules-text-title">APP定制开发</p>
        <p class="modules-content">从产品、业务、运营、技术角</p>
        <p class="modules-content">度提供IOS\Android\混合开发</p>
      </div>
    </div>
    <div class="modules-right reveal-right">
      <div class="modules-right-text">
        <p class="modules-text-title">微信定制开发</p>
        <p class="modules-content">微信公众号、小程序</p>
        <p class="modules-content">微信矩阵建设服务</p>
      </div>
      <div class="modules-right-img">
        <img class="image" src="../assets/img/ic_2.png"/>
      </div>
    </div>

    <div class="modules-area reveal-left">
      <div class="modules-img">
        <img class="image" src="../assets/img/ic_3.png"/>
      </div>
      <div class="modules-text">
        <p class="modules-text-title">行业应用系统开发</p>
        <p class="modules-content">教育、医疗、电商、零售、制</p>
        <p class="modules-content">造业、社交等20+行业软件开发</p>
      </div>
    </div>

    <div class="modules-right reveal-right">
      <div class="modules-right-text">
        <p class="modules-text-title">高端网站建设</p>
        <p class="modules-content">业务型、展示型、功能型</p>
        <p class="modules-content"> 营销型高端网站建设</p>
      </div>
      <div class="modules-right-img">
        <img class="image" src="../assets/img/ic_4.png"/>
      </div>
    </div>

    <div class="phone-submit">
      <img src="../assets/img/bz36.png"/>
      <div class="submit-content">
        <van-field v-model="userPhone" type="number" class="z-input" label="手机号码" colon clearable
                   placeholder="请输入您的手机号码"/>
        <button class="btn-submit" @click="submitPhone">提交</button>
      </div>
    </div>

    <div class="scheme">
      <img src="../assets/img/tetle.svg" class="scheme-img"/>
    </div>
    <div class="can-assign">
      <p class="assign-title">技术赋能合作伙伴高效增长</p>
      <p class="assign-num">
        <span>{{swipeCurrent}}</span>
        <span>/</span>
        <span>{{banner.length}}</span>
      </p>
    </div>
    <!--轮播图区域-->
    <div class="swiper-area">
      <!--轮播图区域-->
      <div class="examples">
        <div class="bannerBox">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in banner" :key="index"
              >
                <img :src="item.picture_path"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="scheme">
      <img src="../assets/img/title3.png" class="scheme-img"/>
    </div>

    <div class="product-area">
      <div class="product-item">
        <img src="../assets/img/ic1.png"/>
        <p>定位理论</p>
      </div>
      <div class="product-item">
        <img src="../assets/img/i6.png"/>
        <p>4P模型</p>
      </div>
      <div class="product-item">
        <img src="../assets/img/ic／3.png"/>
        <p>交互体验模型</p>
      </div>
      <div class="product-item">
        <img src="../assets/img/ic／4.png"/>
        <p>用户旅程地图</p>
      </div>
      <div class="product-item">
        <img src="../assets/img/ic／5.png"/>
        <p>MVP模型</p>
      </div>
      <div class="product-item">
        <img src="../assets/img/ic／6.png"/>
        <p>AARRR增长模型</p>
      </div>
      <div class="product-item">
        <img src="../assets/img/ic／7.png"/>
        <p>分布式架构</p>
      </div>
      <div class="product-item">
        <img src="../assets/img/ic／8.png"/>
        <p>技术安全架构</p>
      </div>
    </div>

    <div class="scheme">
      <img src="../assets/img/title2.png" class="scheme-img"/>
    </div>
    <div class="industry">
      <div class="industry-item industry-item1 reveal-left">
        <img src="../assets/img/icon／1.png"/>
        <p class="industry-title">定制化解决方案</p>
        <!--<div class="line"></div>-->
        <p class="industry-content">
          丰富的策划经验+资深的开发能力，为您提供一站式满分服务
        </p>
        <div class="industry-button" @click="seeDetails">
          免费获取
        </div>
      </div>
      <div class="industry-item industry-item2 reveal-right">
        <img src="../assets/img/icon／2.png"/>
        <p class="industry-title">生活服务解决方案</p>
        <p class="industry-content">
          结合互联网技术,覆盖各大平台流量入口,打造便捷化的生活模式
        </p>
        <div class="industry-button" @click="seeDetails">
          免费获取
        </div>
      </div>
      <div class="industry-item industry-item3 reveal-left">
        <img src="../assets/img/icon／3.png"/>
        <p class="industry-title">在线教育解决方案</p>
        <p class="industry-content">
          多种变现形式,实现“线上+线下”的知识变现,让知识价值最大化
        </p>
        <div class="industry-button" @click="seeDetails">
          免费获取
        </div>
      </div>
      <div class="industry-item industry-item4 reveal-right">
        <img src="../assets/img/icon／4.png"/>
        <p class="industry-title">智慧医疗解决方案</p>
        <p class="industry-content">
          提供最专业的互联网+医疗健康解决方案
        </p>
        <div class="industry-button" @click="seeDetails">
          免费获取
        </div>
      </div>
      <div class="industry-item industry-item5 reveal-left">
        <img src="../assets/img/icon／5.png"/>
        <p class="industry-title">新零售解决方案</p>
        <p class="industry-content">
          打通线下线上流量入口为零售行业赋能实现零售增长
        </p>
        <div class="industry-button" @click="seeDetails">
          免费获取
        </div>
      </div>
      <div class="industry-item industry-item6 reveal-right">
        <img src="../assets/img/icon／5.png"/>
        <p class="industry-title">电商解决方案</p>
        <p class="industry-content">
          帮助企业搭建新一代的线上社交销售体系,快速实现流量聚拢与商业变现
        </p>
        <div class="industry-button" @click="seeDetails">
          免费获取
        </div>
      </div>
    </div>

    <div class="scheme">
      <img src="../assets/img/title4.png" class="scheme-img"/>
    </div>

    <div class="procedure">
      <img src="../assets/img/procedure.png" class="scheme-img"/>
    </div>

    <div class="scheme">
      <img src="../assets/img/jf.png" class="scheme-img"/>
    </div>

    <div class="repertoire">
      <div class="repertoire-bgc">
        <div class="repertoire-item">
          <img src="../assets/img/icon／1.png"/>
          <p>源代码</p>
        </div>
        <div class="repertoire-item">
          <img src="../assets/img/ic／02.png"/>
          <p>需求文档</p>
        </div>
        <div class="repertoire-item">
          <img src="../assets/img/ic／03.png"/>
          <p>交互原型</p>
        </div>
        <div class="repertoire-item">
          <img src="../assets/img/ic／05.png"/>
          <p>UI效果图</p>
        </div>
        <div class="repertoire-item">
          <img src="../assets/img/ic／05.png"/>
          <p>技术部署</p>
        </div>
        <div class="repertoire-item">
          <img src="../assets/img/sj.png"/>
          <p>数据说明</p>
        </div>
        <div class="repertoire-item">
          <img src="../assets/img/ic／07.png"/>
          <p>接口说明</p>
        </div>
        <div class="repertoire-item">
          <img src="../assets/img/ic／08.png"/>
          <p>测试方案</p>
        </div>
      </div>
    </div>

    <div class="demand">
      <div class="demand-bgc">
        <div class="demand-content">
          <p>·资深产品技术顾问</p>
          <p>·提供项目解决方案及报价方案</p>
          <p>·免费提供企业转型建设方案</p>
        </div>
      </div>
      <div class="demand-form">
        <van-field v-model="nameValue" class="z-input-radis" label="姓名" colon clearable placeholder="请输入您的姓名"/>
        <van-field v-model="phoneValue" type="number" class="z-input-radis" label="手机号码" colon clearable
                   placeholder="请输入您的手机号码"/>
        <van-field v-model="corporation" class="z-input-radis" label="公司名称" colon clearable placeholder="请输入您的公司名称"/>
        <van-field v-model="demandValue" type="textarea" class="z-input-radis" label="需求描述" colon clearable
                   placeholder="请简述您的需求"/>
        <div class="receive" @click="receiveClick">
          立即免费领取
        </div>
      </div>
    </div>
    <van-overlay :show="show">
      <div class="overTier">
        <div class="demand">
          <div class="demand-bgc">
            <div class="demand-content">
              <p>·资深产品技术顾问</p>
              <p>·提供项目解决方案及报价方案</p>
              <p>·免费提供企业转型建设方案</p>
            </div>
          </div>
          <div class="demand-form">
            <van-field v-model="nameValue" class="z-input-radis" label="姓名" colon clearable placeholder="请输入您的姓名"/>
            <van-field v-model="phoneValue" type="number" class="z-input-radis" label="手机号码" colon clearable
                       placeholder="请输入您的手机号码"/>
            <van-field v-model="corporation" class="z-input-radis" label="公司名称" colon clearable
                       placeholder="请输入您的公司名称"/>
            <van-field v-model="demandValue" type="textarea" class="z-input-radis" label="需求描述" colon clearable
                       placeholder="请简述您的需求"/>
            <div class="receive" @click="receiveClick">
              立即免费领取
            </div>
          </div>
        </div>
        <div class="ic_delect">
          <img src="../assets/img/ic_del.png" @click="show=false"/>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import scrollReveal from 'scrollreveal';
  import Vue from 'vue';
  import utils from '../utils/utils.js';
  import Swiper from "swiper";
  import {Field, Swipe, SwipeItem, Lazyload, Overlay, Toast} from 'vant';

  Vue.use(Field, Swipe, SwipeItem, Lazyload, Overlay, Toast);
  export default {
    name: 'Home',
    data() {
      return {
        banner: [
          {
            id: 1,
            picture_path: require('../assets/img/pic_one.png'),
          },
          {
            id: 2,
            picture_path: require('../assets/img/pic_two.png'),
          },
          {
            id: 3,
            picture_path: require('../assets/img/pic_three.png'),
          }
        ],
        scrollReveal: scrollReveal(),
        userPhone: '',//手机号
        zxURL: require("../assets/img/dhx.png"),
        nameValue: '',//姓名
        corporation: '',//公司
        phoneValue: '',//表单=>手机号码
        demandValue: '',//需求描述
        companyPhone: '',//公司电话
        swipeCurrent: '',//当前轮播图的序号
        show: false,
        mySwiper: null,
        test: null
      }
    },
    watch: {
      mySwiper: {
        handler(e) {
          this.swipeCurrent = e.test;
        },
        deep: true
      }
    },
    mounted() {
      this.mySwiper = new Swiper('.swiper-container', {
        direction: 'horizontal',
        loop: true,
        autoplay: 1000,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 10, // 在slide之间设置距离（单位px）。
        loopAdditionaSlider: 0,
        on: {
          slideChangeTransitionEnd: function (e) {
            this.test = e.realIndex + 1;
            console.log(this.test);
          },
        },
      });

      this.scrollReveal.reveal('.reveal-left', {
        // 动画的时长
        duration: 1000,
        // 延迟时间
        delay: 100,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: 'left',
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: true,
        // 滚动的距离，单位可以用%，rem等
        distance: '100px',
        // 其他可用的动画效果
        opacity: 0.001,
        easing: 'linear',
        scale: 0.9,
      });

      this.scrollReveal.reveal('.reveal-right', {
        duration: 1000,
        delay: 100,
        origin: 'right',
        reset: false,
        mobile: true,
        distance: '200px',
        opacity: 0.001,
        easing: 'linear',
        scale: 0.9,
      });
    },
    created() {
      utils.setTitle("「深圳云伙伴科技」-小程序开发-APP定制-软件公司");
    },
    methods: {
      // 显示需求表单
      seeDetails() {
        this.show = true;
      },
      //字符串去除空格
      delectStr(val) {
        return val.replace(/\s*/g, "");
      },
      //加载中
      ToastTime(val) {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: val
        });
      },
      // 手机号码提交
      submitPhone() {
        let _this = this;
        _this.userPhone = _this.delectStr(_this.userPhone);
        if(_this.userPhone === ''){
          Toast.fail('请输入手机号')
        }else {
          _this.postres(_this.userPhone);
        }
      },
      //表单提交
      receiveClick() {
        let _this = this;
        if ((_this.nameValue = _this.delectStr(_this.nameValue)) === '') {
          Toast.fail('请输入姓名');
        } else if ((_this.phoneValue = _this.delectStr(_this.phoneValue)) === '') {
          Toast.fail('请输入手机号');
        } else if ((_this.corporation = _this.delectStr(_this.corporation)) === '') {
          Toast.fail('请输入公司名称');
        } else if ((_this.demandValue = _this.delectStr(_this.demandValue)) === '') {
          Toast.fail('请简述需求');
        } else {
          _this.postres(_this.phoneValue);
        }
      },
      // 请求抽离
      postres(phone) {
        let _this = this;
        _this.ToastTime(0);
        _this.$axios.post('https://api.yhbit.cn/v1/app/Consultation', {
          user_name: _this.nameValue === '' ? _this.nameValue = '默认用户' : _this.nameValue,
          user_mobile: phone,
          type: _this.corporation === '' ? _this.corporation = '默认公司' : _this.corporation,
          content: _this.demandValue === '' ? _this.demandValue = '默认描述' : _this.demandValue
        }).then(function (response) {
          console.log(response);
          if (response.status === 200) {
            _this.ToastTime(1);
            Toast.success('提交成功!');
            _this.nameValue = '';
            _this.phoneValue = '';
            _this.corporation = '';
            _this.demandValue = '';
            _this.userPhone = '';
          } else {
            Toast.fail('提交失败');
          }
        })
          .catch(function (error) {
            console.log(error);
          });
      },
    }
  }
</script>
<style scoped lang="less">
  @import "home.css";

  .examples {
    .tips {
      position: absolute;
      bottom: 0px;
      width: 100%;
      height: 46px;
      background-color: #b5654d;
      text-align: center;
      img {
        width: 12px;
        height: 14px;
        position: absolute;
        top: 7.5px;
        left: 12vw;
        color: #fff;
      }
      p {
        width: 240px;
        text-align: left;
        color: #fff;
        font-size: 12px;
        position: absolute;
        left: 18vw;
        top: 7px;
        line-height: 16px;
      }
    }
  }

  .bannerTxt {
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #666666;
    font-size: 15px;
  }

  .bannerIndex {
    line-height: 40px;
    text-align: center;
    color: #666666;
    font-size: 15px;
    text-align: center;
    span {
      color: #b5654d;
    }
  }

  .bannerBox {
    position: relative;
    height: 370px;
  }

  .swiper-container {
    width: 100%;
    height: 100%;
  }

  .swiper-container .swiper-wrapper .swiper-slide {
    width: 80% !important;
    overflow: hidden;
    display: flex;
    align-items: center;
  }

  .swiper-container .swiper-wrapper .swiper-slide img {
    width: 100%;
    height: 370px;
    border-radius: 5px;
  }

  .swiper-container .swiper-wrapper .swiper-slide-prev, .swiper-container .swiper-wrapper .swiper-slide-next {
    height: 340px;
    margin-top: 20px;
  }

  .swiper-container .swiper-wrapper .swiper-slide-prev img, .swiper-container .swiper-wrapper .swiper-slide-next img {
    width: 100%;
    height: 100%;
  }

</style>
